import angular from 'angular'
import template from './template.html'

function NominasSharedEmpleadoSeleccionarComponent($dialogParams, dialog, $dialog, $scope, $filter, $catalogos) {
  let $ctrl = this,
    toArray = $filter('toArray'),
    orderBy = $filter('orderBy');

  $ctrl.$close = cerrar;
  $ctrl.$select = seleccionar;
  $ctrl.$add = agregar;
  $ctrl.catalogos = {
    Empresas: toArray($dialogParams['companies']),
    Empleados: undefined,
  };
  $ctrl.options = {
    searchFor: $dialogParams['searchFor'],
    Empresa: $ctrl.catalogos.Empresas.length == 1 ? $ctrl.catalogos.Empresas[0] : undefined,
    Empleado: undefined,
  };

  $scope.$watch('$ctrl.options.Empresa', obtenerEmpleados);

  function cerrar() {
    dialog.reject();
  }

  function seleccionar() {
    dialog.resolve($ctrl.options.Empleado);
  }

  function agregar() {
    $dialog.show('empleado.agregar', {
      idEmpresa: $ctrl.options.Empresa.ID,
      empresa: $ctrl.options.Empresa.Descripcion,
    }).then(function (data) {
      $ctrl.catalogos.Empleados.push(data);
      $ctrl.options.Empleado = data;
    });
  }

  function obtenerEmpleados() {
    if ($ctrl.options.Empresa) {
      $ctrl.loading = true;

      $ctrl.catalogos.Empleados = undefined;

      $catalogos.get('empleados', {ID_Empresa: $ctrl.options.Empresa.ID})
        .then(function (list) {
          $ctrl.catalogos.Empleados = list;
        }).finally(function () {
        $ctrl.loading = false;
      });
    }
  }
}

angular.module('nominas.shared')
  .controller('NominasSharedEmpleadoSeleccionar', NominasSharedEmpleadoSeleccionarComponent)
  .config(($dialogProvider) => {
    $dialogProvider.dialog('empleado.select', {
      controller: 'NominasSharedEmpleadoSeleccionar',
      template: template,
      controllerAs: '$ctrl',
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/shared/components/empleado/seleccionar/component.js